export default __webpack_public_path__ + "static/media/ivana-cajina-dQejX2ucPBs-unsplash.e5d08f7a.jpg";